import React from "react";
import "./HistoryCard.sass";

export const HistoryCard = ({ data }) => {
  const isLong = data.type === "Long";
  const isPnlPositive = data.pnl.startsWith("+");

  return (
    <div className="history-card">
      {/* 1. CARD HEADER */}
      <div className="history-card__header">
        <div className="history-card__title-group">
          <img src={data.icon} alt={data.pair} className="history-card__icon" />
          <div className="history-card__title-info">
            <span className="history-card__pair">{data.pair}</span>
            <div className="history-card__badges">
              <span
                className={`history-card__badge ${
                  isLong
                    ? "history-card__badge--long"
                    : "history-card__badge--short"
                }`}
              >
                {data.type} {data.leverage}
              </span>
              <span className="history-card__badge history-card__badge--gray">
                {data.margin}
              </span>
            </div>
          </div>
        </div>
        <span className="history-card__status">{data.status}</span>
      </div>

      {/* 2. STATS GRID */}
      <div className="history-card__stats">
        {/* Column 1 */}
        <div className="history-card__stat-col">
          <div className="history-card__stat-item">
            <span className="history-card__label">Entry price</span>
            <span className="history-card__value">{data.entry}</span>
          </div>
          <div className="history-card__stat-item">
            <span className="history-card__label">Exit price</span>
            <span className="history-card__value">{data.exit}</span>
          </div>
        </div>

        {/* Column 2 */}
        <div className="history-card__stat-col">
          <div className="history-card__stat-item">
            <span className="history-card__label history-card__label--dashed">
              Realized PnL
            </span>
            <span
              className={`history-card__value ${
                isPnlPositive
                  ? "history-card__value--green"
                  : "history-card__value--red"
              }`}
            >
              {data.pnl}
            </span>
          </div>
          <div className="history-card__stat-item">
            <span className="history-card__label">Realized PnL%</span>
            <span
              className={`history-card__value ${
                isPnlPositive
                  ? "history-card__value--green"
                  : "history-card__value--red"
              }`}
            >
              {data.pnlPercent}
            </span>
          </div>
        </div>

        {/* Column 3 (Right Aligned) */}
        <div className="history-card__stat-col history-card__stat-col--right">
          <div className="history-card__stat-item">
            <span className="history-card__label">Max held</span>
            <span className="history-card__value">{data.maxHeld}</span>
          </div>
          <div className="history-card__stat-item">
            <span className="history-card__label">Closed</span>
            <span className="history-card__value">{data.closedAmount}</span>
          </div>
        </div>
      </div>

      {/* 3. DATES FOOTER */}
      <div className="history-card__footer">
        <div className="history-card__date-row">
          <span className="history-card__label">Opened</span>
          <span className="history-card__date">{data.openedDate}</span>
        </div>
        <div className="history-card__date-row">
          <span className="history-card__label">Closed</span>
          <span className="history-card__date">{data.closedDate}</span>
        </div>
      </div>
    </div>
  );
};
